export default __webpack_public_path__ + "static/media/r2.871f16f1.jpg";